module.exports = __webpack_public_path__ + "assets/f8deb75705d143edca566a028a281c50.svg";